import { unref as _unref, resolveDynamicComponent as _resolveDynamicComponent, openBlock as _openBlock, createBlock as _createBlock, KeepAlive as _KeepAlive, resolveComponent as _resolveComponent, withCtx as _withCtx, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, createElementBlock as _createElementBlock } from "vue";
import _imports_0 from '@/assets/imgs/mail_fill.webp';
const _hoisted_1 = {
  id: "app"
};
const _hoisted_2 = {
  key: 2,
  style: {
    "position": "fixed",
    "right": "5%",
    "bottom": "5%",
    "width": "7rem",
    "height": "7rem",
    "z-index": "100000"
  }
};
const _hoisted_3 = /*#__PURE__*/_createElementVNode("img", {
  style: {
    "height": "100%"
  },
  src: _imports_0,
  alt: "icon"
}, null, -1);
const _hoisted_4 = [_hoisted_3];
import { ref, onMounted } from "vue";
import { useStore } from "./store";
import { useRoute } from "vue-router";
export default {
  __name: 'App',
  setup(__props) {
    const router = useRoute();
    const screenWidth = ref(0);
    const timer = ref(null);
    const store = useStore();
    onMounted(() => {
      screenWidth.value = document.body.clientWidth;
      document.getElementsByTagName("html")[0].style.fontSize = "12px";
      store.setScreenWidth(document.body.clientWidth);
      window.onscroll = () => {
        store.setScrollHeight_before();
        store.setScrollHeight(document.body.scrollTop || document.documentElement.scrollTop);
      };
      window.addEventListener("resize", () => {
        if (!timer.value) {
          timer.value = setTimeout(function () {
            screenWidth.value = document.body.clientWidth;
            document.getElementsByTagName("html")[0].style.fontSize = "12px";
            store.setScreenWidth(document.body.clientWidth);
            timer.value = null;
          }, 400);
        }
      });
    });
    function gtag_report_conversion(url) {
      var callback = function () {
        if (typeof url != "undefined") {
          window.location = url;
        }
      };
      gtag("event", "conversion", {
        send_to: "AW-949439480/4SCwCPfLsvQYEPiX3cQD",
        event_callback: callback
      });
      return false;
    }
    return (_ctx, _cache) => {
      const _component_router_view = _resolveComponent("router-view");
      return _openBlock(), _createElementBlock("div", _hoisted_1, [!_unref(store).isPC ? (_openBlock(), _createBlock(_component_router_view, {
        key: 0
      }, {
        default: _withCtx(({
          Component
        }) => [(_openBlock(), _createBlock(_KeepAlive, null, [(_openBlock(), _createBlock(_resolveDynamicComponent(Component), {
          key: _unref(router).name
        }))], 1024))]),
        _: 1
      })) : (_openBlock(), _createBlock(_component_router_view, {
        key: 1
      }, {
        default: _withCtx(({
          Component
        }) => [(_openBlock(), _createBlock(_resolveDynamicComponent(Component), {
          key: _unref(router).name
        }))]),
        _: 1
      })), _unref(store).isPC ? (_openBlock(), _createElementBlock("div", _hoisted_2, [_createElementVNode("a", {
        href: "mailto:info@fusteel.com",
        class: "email_address",
        onClick: _cache[0] || (_cache[0] = $event => gtag_report_conversion())
      }, _hoisted_4)])) : _createCommentVNode("", true)]);
    };
  }
};